import React from 'react';

const WelcomeMessage = () => (
  <section className="py-12 px-4 max-w-3xl mx-auto text-center">
    <h2 className="text-2xl font-bold mb-4">WELCOME MESSAGE</h2>
    <p className="text-lg mb-2">
      Hi there! Thank you for checking out our website.
    </p>
    <p className="mb-2">
      We'll love for you to know that VitalBridge operates at the intersection of four pillars: <b>Education</b>, <b>Healthcare</b>, <b>Environmental Sustainability</b>, and <b>Human Capacity Development</b>.
    </p>
    <p className="mb-2">
      Through strategic partnerships and community engagement, we aim to create meaningful impact that improves lives today and lays the foundation for a stronger tomorrow.
    </p>
    <p className="mb-2">
      We believe that a good future starts with today's actions, and so we're focused on turning vision into action.
    </p>
    <p>
      You too can be a part of this transformative journey!
    </p>
  </section>
);

export default WelcomeMessage;